import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
//import './TimeSlotRow.scss';
import TimeSlotDay from '../TimeSlotDay/TimeSlotDay.jsx';

class TimeSlotRow extends Component {

  renderTds(days, numDaysShow, page, numDays) {
    // TODO: this needs to be passed in because this logic should be handled by
    // the cal and passed to this component
    let temp = [];
    let start = 0 + (page*numDaysShow);
    let end = start + numDaysShow;

    while (end > numDays) {
      end--;
      start--;
    }

    for (let i=start; i<end; i++) {
      temp.push(days[i]);
    }

    return temp;
  }

  render() {
    const classes = 'hg-timeSlotRow';

    const {
      children,
      className,
      days,
      numDaysShow,
      numDays, // maxDays
      page,
      setSelectedTimeSlot,
      selectedTimeSlot
    } = this.props;

    if (!days) return;

    return (
      <tr {...this.props} className={classNames(className, classes)}>
          {this.renderTds(days, numDaysShow, page, numDays).map((day, i) =>
            <TimeSlotDay
              key={i}
              day={day}
              dispatchSelectTimeSlot={setSelectedTimeSlot}
              selectedTimeSlot={selectedTimeSlot}
            />
          )}
        {children}
      </tr>
    );
  }
}

TimeSlotRow.propTypes = {
    children: PropTypes.node,
    days: PropTypes.array.isRequired,
    className: PropTypes.string,
    startDate: PropTypes.string.isRequired,
    numDaysShow: PropTypes.number.isRequired,
    numDays: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    setSelectedTimeSlot: PropTypes.func,
    selectedTimeSlot: PropTypes.string
};

export default TimeSlotRow;



/** WEBPACK FOOTER **
 ** ./client/shared/packages/TimeSlotCalendar/src/TimeSlotRow/TimeSlotRow.jsx
 **/